import { activationApiService } from "app/pages/activation/services/api/data";
import { gaApiService } from "app/pages/activation/services/api/googleAnalytics";
import { rankTrackerApiService } from "app/pages/activation/services/api/rankTracker";
import { topicsApiService } from "app/pages/activation/services/api/topics";
import defaultFetchServiceOverride from "app/pages/activation/services/defaultFetchServiceOverride";

import { homeWithData } from "./api/homeWithData";
import { setupApiService } from "./api/setup";

export const createActivationApi = () => {
    return {
        activation: activationApiService(defaultFetchServiceOverride),
        homeWithData: homeWithData(defaultFetchServiceOverride),
        ga: gaApiService(defaultFetchServiceOverride),
        topics: topicsApiService(defaultFetchServiceOverride),
        setup: setupApiService(defaultFetchServiceOverride),
        rankTracker: rankTrackerApiService(defaultFetchServiceOverride),
    };
};
